import { LANGUAGE_EN, LANGUAGE_ES } from '../languages/constants'
import { Language } from '../languages/types'

export const supportedLanguages: Language[] = [LANGUAGE_EN, LANGUAGE_ES]
